export default __webpack_public_path__ + "images/icono-tlajochat.7bbcde91f0288c6b379168eaadd7e676.svg";